import React from 'react';
import { Navigate } from 'react-router-dom';

// Keep legacy URLs working while placing user management with access control.
export default function UsersPage() {
  return <Navigate to="/settings/access-control?tab=users" replace />;
}
